import { timeSince } from "~/public_html/dfm5";

export function groupResourcesByTimeSince(resources) {
  let groupedResources = [];
  resources.forEach((resource) => {
    const dateObject = new Date(resource.created);
    const dateString = timeSince(dateObject.getTime() / 1000);
    const index = groupedResources.findIndex(
      (obj) => obj.dateString === dateString,
    );
    if (index === -1) {
      groupedResources.push({ dateString, resources: [resource] });
    } else {
      groupedResources[index].resources.push(resource);
    }
  });
  return groupedResources;
}

export function attachCountsToCourse(course, unitCounts) {
  const modules = course.modules ?? [];
  const modulesWithCounts = modules.map((module) => {
    let moduleCount = 0;
    const units = module.units ?? [];
    const unitsWithCounts = units.map((unit) => {
      const unitCount = unitCounts?.find((u) => u.cuid === unit.cuid)?.count ?? 0;
      moduleCount += unitCount;
      return {
        ...unit,
        tag: `${unitCount} resource${unitCount === 1 ? "" : "s"}`,
        disabled: unitCount === 0,
      };
    });
    return {
      ...module,
      units: unitsWithCounts,
      tag: `${moduleCount} resource${moduleCount === 1 ? "" : "s"}`,
    };
  });
  return { ...course, modules: modulesWithCounts };
}
